import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';
import { getOneClickPreloadedOrder } from './one-click-profiles.selector';

export const getOneClickPlantsState = createSelector(getOneClickState, state => state.plansState);

export const getOneClickPlants = (index: number) =>
  createSelector(getOneClickPlantsState, state => state.plantsAvailable[index]);

export const getOneClickPlantsSelected = createSelector(getOneClickPlantsState, state => state.selected);

export const plantWithPreloaded = (index: number) =>
  createSelector(getOneClickPlants(index), getOneClickPreloadedOrder, (plants, preloadedOrder) => ({
    plants,
    preloadedOrder,
  }));
